/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HchbPayorTypeSummary } from './HchbPayorTypeSummary';
import {
    HchbPayorTypeSummaryFromJSON,
    HchbPayorTypeSummaryFromJSONTyped,
    HchbPayorTypeSummaryToJSON,
} from './HchbPayorTypeSummary';

/**
 * 
 * @export
 * @interface HchbPayorTypePage
 */
export interface HchbPayorTypePage {
    /**
     * 
     * @type {Array<HchbPayorTypeSummary>}
     * @memberof HchbPayorTypePage
     */
    data: Array<HchbPayorTypeSummary>;
    /**
     * 
     * @type {number}
     * @memberof HchbPayorTypePage
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof HchbPayorTypePage
     */
    limit: number;
    /**
     * 
     * @type {number}
     * @memberof HchbPayorTypePage
     */
    total: number;
    /**
     * 
     * @type {boolean}
     * @memberof HchbPayorTypePage
     */
    has_next: boolean;
}

/**
 * Check if a given object implements the HchbPayorTypePage interface.
 */
export function instanceOfHchbPayorTypePage(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "limit" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "has_next" in value;

    return isInstance;
}

export function HchbPayorTypePageFromJSON(json: any): HchbPayorTypePage {
    return HchbPayorTypePageFromJSONTyped(json, false);
}

export function HchbPayorTypePageFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPayorTypePage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(HchbPayorTypeSummaryFromJSON)),
        'page': json['page'],
        'limit': json['limit'],
        'total': json['total'],
        'has_next': json['has_next'],
    };
}

export function HchbPayorTypePageToJSON(value?: HchbPayorTypePage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(HchbPayorTypeSummaryToJSON)),
        'page': value.page,
        'limit': value.limit,
        'total': value.total,
        'has_next': value.has_next,
    };
}

